<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container main_bg">
      <i-card-vertical headerTitle="세금계산서 미발행" :IsUseEditorBox="true" :IsUseInnerAddition="true" device="web">
        <template v-slot:EditorBox>
          <v-row no-gutters>
            <span class="d-flex align-center"> 거래일자 : </span>
            <v-col>
              <i-date-time-picker
                :firstDisplayDate="startDate"
                placeholder="시작일자"
                class="mx-1"
                :dateOnly="true"
                @getDate="setSearchDate($event, 'start')"
                :allowMaxDate="setDateFormat(searchEndDate, '-')"
              ></i-date-time-picker>
            </v-col>
            <span class="pt-1">~</span>
            <v-col>
              <i-date-time-picker
                :firstDisplayDate="endDate"
                placeholder="종료일자"
                class="mx-1"
                :dateOnly="true"
                @getDate="setSearchDate($event, 'end')"
                :allowMinDate="setDateFormat(searchStartDate, '-')"
              ></i-date-time-picker>
            </v-col>
          </v-row>
        </template>
        <template v-slot:body>
          <v-layout column>
            <v-col cols="12" md="12" class="row pa-0">
              <v-col cols="12" class="pa-0">
                <DxDataGrid
                  id="taxInvoiceManageDataGrid"
                  class="layout-col-height00"
                  :selection="{ mode: 'single' }"
                  style="width: 100%; height: 100%"
                  :ref="dxDataGridRef"
                  :data-source="gridMain"
                  :remote-operations="false"
                  :hover-state-enabled="true"
                  :allow-column-reordering="true"
                  :allow-column-resizing="true"
                  :row-alternation-enabled="true"
                  :column-auto-width="true"
                  :show-borders="true"
                  :show-row-lines="true"
                  :focused-row-enabled="true"
                  key-expr="seq"
                >
                  <DxColumn
                    data-field="detail"
                    data-type="string"
                    width="100px"
                    alignment="center"
                    caption="발급하기"
                    :allow-editing="false"
                    cell-template="actionTemplete"
                  ></DxColumn>
                  <template #actionTemplete="{ data: cellInfo }">
                    <div>
                      <v-btn color="primary" elevation="0" small @click="btnIssue(cellInfo)" class="grid-btn">발급하기</v-btn>
                    </div>
                  </template>
                  <DxColumn
                    data-field="genTm"
                    data-type="date"
                    alignment="center"
                    width="120px"
                    caption="거래일자"
                    format="yyyy.MM.dd"
                    :allow-editing="false"
                  />
                  <DxColumn data-field="clntNm" data-type="string" alignment="center" width="300px" caption="고객사명" :allow-editing="false" />
                  <DxColumn
                    data-field="buyRegnum"
                    data-type="string"
                    alignment="center"
                    width="150px"
                    caption="사업자등록번호"
                    :allow-editing="false"
                  />
                  <DxColumn data-field="buyEmployer" data-type="string" alignment="center" width="100px" caption="대표자" :allow-editing="false" />
                  <DxColumn data-field="constructNm" data-type="string" alignment="left" width="300px" caption="사업장명" :allow-editing="false" />
                  <DxColumn data-field="representativeOrderId" data-type="string" alignment="center" width="350px" caption="대표 주문번호" :allow-editing="false" />
                  <DxColumn data-field="orderId" data-type="string" alignment="center" width="350px" caption="주문번호" :allow-editing="false" />
                  <DxColumn
                    data-field="orderType"
                    data-type="string"
                    alignment="center"
                    width="100px"
                    caption="결제수단"
                    :allow-editing="false"
                    cell-template="orderTypeCellTemplate"
                  />
                  <template #orderTypeCellTemplate="{ data: cellInfo }">
                    <div v-if="cellInfo.value === 'PG'">
                      <span>신용카드</span>
                    </div>
                    <div v-else-if="cellInfo.value === 'AC'">
                      <span>계좌이체</span>
                    </div>
                  </template>
                  <DxColumn
                    data-field="paymentTotal"
                    data-type="number"
                    alignment="right"
                    width="150px"
                    caption="결제 총액"
                    :allow-editing="false"
                    cell-template="amountCellTemplate"
                  />
                  <DxColumn
                    data-field="taxbillTotal"
                    data-type="number"
                    alignment="right"
                    width="150px"
                    caption="세금계산서 총액"
                    :allow-editing="false"
                    cell-template="amountCellTemplate"
                  />
                  <DxColumn
                    data-field="taxSupprice"
                    data-type="number"
                    alignment="right"
                    width="150px"
                    caption="발급 공급가액"
                    :allow-editing="false"
                    cell-template="amountCellTemplate"
                  />
                  <DxColumn
                    data-field="taxTaxprice"
                    data-type="number"
                    alignment="right"
                    width="150px"
                    caption="발급 세액"
                    :allow-editing="false"
                    cell-template="amountCellTemplate"
                  />
                  <!-- <DxColumn
                    data-field="payTotalprice"
                    data-type="number"
                    alignment="right"
                    width="150px"
                    caption="합계금액"
                    :allow-editing="false"
                    cell-template="amountCellTemplate"
                  /> -->
                  <template #amountCellTemplate="{ data: cellInfo }">
                    <div v-if="cellInfo.value === '-'">{{ '-' }}</div>
                    <div v-else>{{ formatToKoreanWon(cellInfo.value) + '원' }}</div>
                  </template>
                  <DxSummary :calculate-custom-summary="calculateCustomSummary">
                    <DxTotalItem column="taxSupprice" summary-type="sum" display-format="{0}원" :customize-text="customizeText" />
                    <DxTotalItem column="taxTaxprice" summary-type="sum" display-format="{0}원" :customize-text="customizeText" />
                    <DxTotalItem column="payTotalprice" summary-type="sum" display-format="{0}원" :customize-text="customizeText" />
                  </DxSummary>
                </DxDataGrid>
              </v-col>
            </v-col>
          </v-layout>
        </template>
      </i-card-vertical>
      <i-card-right headerTitle :useBtnList="buttonUseList" :reportItems="reportItems" @btnSearch="btnSearch(true)" @btnPrint="btnPrint">
        <template v-slot:body>
          <v-layout>
            <v-row no-gutters class="pa-0 pt-2">
              <v-col cols="12" md="4"></v-col>
            </v-row>
          </v-layout>
        </template>
      </i-card-right>
    </v-sheet>
  </v-container>
</template>
<script>
import { getClientPaymentHistoryList } from '@/payment/api/clientPaymentHistory'
import IDateTimePicker from '@/components/common/iDateTimePicker.vue'
import { getCurrentDate, getPreMonth } from '@/utils/common.js'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue'
import baseview from '@/views/base/baseview.vue'

import iDxPopup from '@/components/common/iDxPopup.vue'
import TaxInvoiceStatusPopup from '@/views/adminManagement/TaxInvoiceStatusPopup.vue'

import { Workbook } from 'exceljs'
import { saveAs } from 'file-saver-es'
import { exportDataGrid as exportExcel } from 'devextreme/excel_exporter'
import { getClientManageDetail } from '@/api/adminManagement/clientManage'

// api
import {
  getUnissuedClient, // 미발행 업체 조회
} from '@/payment/api/taxInvoice.js'
export default {
  mixins: [baseview, BaseDataGrid],
  name: 'unIssuedTaxInvoiceManage',
  components: {
    IDateTimePicker,
  },
  data() {
    return {
      dxDataGridRef: 'unIssuedTaxInvoiceManage',
      buttonUseList: [
        'btnSearch', // 조회
        'btnPrint', // 출력
      ],
      reportItems: [{ role: 'xls', title: 'EXCEL' }],
      gridMain: [],
      startDate: getPreMonth(12),
      endDate: getPreMonth(0),
      searchStartDate: getPreMonth(12).replace(/[^0-9]/g, ''),
      searchEndDate: getPreMonth(0).replace(/[^0-9]/g, ''),
      searchMinDate: getCurrentDate(),
      searchMaxDate: getPreMonth(12),
      minDate: getCurrentDate(),
      totalAmount: 0,
    }
  },
  computed: {},
  beforeMount() {},
  activated() {
    if (this.$route.params.data) {
      let params = this.$route.params.data
      if (params.flag) {
        if (params.startDate) {
          // 정산 페이지에서 넘어올 때 조회조건 세팅
          this.startDate = params.startDate
          this.searchStartDate = params.startDate.replaceAll('-', '')
          this.searchMaxDate = params.startDate

          this.endDate = params.endDate
          if (this.endDate > getCurrentDate()) {
            this.endDate = getCurrentDate()
          }
          this.searchEndDate = params.endDate.replaceAll('-', '')
          this.searchMinDate = params.endDate

          this.minDate = params.endDate
        }
        this.btnSearch(true)
      }
    }

    this.btnSearch(true)
  },
  created() {},
  mounted() {
    this.btnSearch(true)
  },
  methods: {
    calculateCustomSummary(options) {
      if (options.summaryProcess === 'start') {
        this.totalAmount = 0
      }
      if (options.summaryProcess === 'finalize') {
        const dataSource = options.component.option('dataSource') // 데이터 소스에서 데이터를 가져오기
        dataSource.forEach((item) => {
          this.totalAmount += parseInt(item.payTotalprice)
        })
        console.log('최종 합계 값:', this.totalAmount)
      }
    },

    customizeText(options) {
      // 출력되는 합계금액 커스텀
      return this.formatToKoreanWon(options.value) + '원'
    },
    formatToKoreanWon(value) {
      if (value) {
        const numberValue = parseFloat(value.toString().replace(/,/g, ''))
        if (!isNaN(numberValue)) {
          return numberValue.toLocaleString('ko-KR')
        }
      } else return 0
    },
    //------------------------------------------
    //  검색 년월일 포맷
    //------------------------------------------
    setSearchDate(e, div) {
      if (div === 'start') {
        this.searchMinDate = e
        this.searchStartDate = e.replace(/[^0-9]/g, '')
      } else if (div === 'end') {
        this.searchMaxDate = e
        this.searchEndDate = e.replace(/[^0-9]/g, '')
      }
      this.btnSearch()
    },
    setDateFormat(date, div = '.') {
      return `${date.substring(0, 4)}${div}${date.substring(4, 6)}${div}${date.substring(6, 8)}`
    },
    //------------------------------------------
    //  고객사 결제 내역 확인 조회
    //------------------------------------------
    async btnSearch(isNotify = true) {
      let params = {
        searchStartDate: this.searchStartDate,
        searchEndDate: this.searchEndDate,
      }
      this.openLoading()
      getUnissuedClient(params, isNotify)
        .then((res) => {
          if (res.success) {
            this.gridMain = res.list
          }
        })
        .catch(() => {
          this.endLoading()
        })
        .finally(() => {
          this.endLoading()
        })
    },

    //------------------------------------------
    //  상세보기 클릭
    //------------------------------------------
    async btnIssue(cellInfo) {
      console.log('@@ cellInfo', cellInfo)
      this.vToastifyPrompt(
        this.$t(`[${cellInfo.data.clntNm}] <br/> 세금계산서 발행페이지로 이동하시겠습니까?`),
        'info',
        (current) => {
          const routerParams = {
            clntId: cellInfo.data.clntId,
            buyRegnum: cellInfo.data.buyRegnum,
            buyCompany: cellInfo.data.clntNm,
            buyEmployer: cellInfo.data.buyEmployer,
            buyAddress: cellInfo.data.buyAddress,
            payTotalprice: cellInfo.data.payTotalprice,
            taxSupprice: cellInfo.data.taxSupprice,
            taxTaxprice: cellInfo.data.taxTaxprice,
            genTm: getCurrentDate(),
            itemList: [
              {
                year: cellInfo.data.genTm.substring(0, 4),
                month: cellInfo.data.genTm.substring(4, 6),
                day: cellInfo.data.genTm.substring(6, 8),
                itemName: cellInfo.data.itemName ?? '위험성평가 소중안 컨설팅',
                feeName: cellInfo.data.feeName ?? '',
                itemUnit: '',
                itemNum: 1,
                itemDanga: cellInfo.data.payTotalprice.toString(),
                taxSupprice: cellInfo.data.taxSupprice,
                taxTaxprice: cellInfo.data.taxTaxprice,
                itemBigo: cellInfo.data.constructNm,
                orderId: cellInfo.data.orderId,
                paymentKey: cellInfo.data.paymentKey,
              },
            ],
          }
          getClientManageDetail({ clntId: cellInfo.data.clntId })
            .then((res) => {
              routerParams.buyBizcond = res.detailNm
              routerParams.buyEmpemail = res.email
              console.log('##routerParams', routerParams)
              const toRouter = {
                name: 'TaxInvoiceManageDetail',
                params: { issueParam: routerParams },
              }
              this.$router.push(toRouter)
            })
            .catch(() => {
              this.endLoading()
            })
            .finally(() => {
              this.endLoading()
            })
        },
        null,
        true
      )
    },
    formatDate(date, div = '.') {
      if (!date) return null

      if (date.indexOf(div) == -1) {
        const year = date.substring(0, 4)
        const month = date.substring(4, 6)
        const day = date.substring(6, 8)
        return `${year}${div}${month}${div}${day}`
      } else if (date.indexOf(div) > -1) {
        const [year, month, day] = date.split(div)
        return `${year}${div}${month}${div}${day}`
      } else {
        return date
      }
    },
    btnPrint(type) {
      if (type == 'xls') {
        const docTitle = `세금계산서 미발행 내역(${this.formatDate(this.searchStartDate)}~${this.formatDate(this.searchEndDate)}).xlsx`
        const workbook = new Workbook()
        const worksheet = workbook.addWorksheet('세금계산서 미발행 내역')
        exportExcel({
          component: this.GetDataGrid(this.dxDataGridRef),
          worksheet,
          autoFilterEnabled: true,
        }).then(() => {
          workbook.xlsx.writeBuffer().then((buffer) => {
            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), docTitle)
          })
        })
      }
    },
  },
}
</script>

<style scoped></style>
